import { redirect } from 'react-router-dom';
import { StorageKeys, StorageService } from 'src/services/storage.service';
import supabaseAuthProviderService, {
  useSupabaseAuthProviderService,
} from '../../../services/supabase-auth-provider.service';

export const logout = async () => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error('Supabase client not found');
  }

  const response = await supabaseClient.auth.signOut({
    scope: 'local',
  });

  if (response.error) {
    await supabaseClient.auth.refreshSession();

    throw response.error;
  }

  StorageService.removeItem(StorageKeys.DIRECTORY_TOKEN);
  supabaseAuthProviderService.clearPersistedProvider();

  redirect('/login');
};

export const login = async (email: string, password: string) => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error('Supabase client not found');
  }

  const response = await supabaseClient.auth.signInWithPassword({
    email,
    password,
  });

  if (response.error) {
    throw response.error;
  }
};

export const refreshSession = async () => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error('Supabase client not found');
  }

  const response = await supabaseClient.auth.refreshSession();

  if (response.error) {
    throw response.error;
  }

  return response;
};
